import { makeStyles } from '@material-ui/core';
import { colors } from '../../styles/styles';

export const useStyles = makeStyles((theme) => ({
  icon: {
    color: colors.info,
  },
}));
